import { ActionTypeKeys, ActionTypes, FetchTrustedPartnersSuccess } from 'common/actions'
import Api from 'common/services/Api'
import * as React from 'react'
import { TrustedPartner, TrustedPartners } from '.'
export const TRUSTED_PARTNER_API_URL = '/uiUtil/featuredFinancialInstitutions'

/**
 * @param partners The array of TrustedPartner objects returned from /featuredFinancialInstitutions
 */

export const fetchTrustedPartnersSuccess = (partners: TrustedPartner[]): FetchTrustedPartnersSuccess => ({
  partners,
  type: ActionTypeKeys.FETCH_TRUSTED_PARTNERS_SUCCESS,
})

/**
 * The reducer to store API returned Trusted Partner logos
 * @param state The array of TrustedPartner objects returned from /featuredFinancialInstitutions
 * @param action Success or Fail actions
 */

const trustedPartnersReducer = (state: TrustedPartner[] = [], action: ActionTypes) => {
  if (action.type === ActionTypeKeys.FETCH_TRUSTED_PARTNERS_SUCCESS) {
    return [...state, ...action.partners]
  }
  return state
}

export interface TrustedPartnerContainerProps {
  direction?: RenderDirection
  staticTrustedPartners?: TrustedPartner[]
}

export enum RenderDirection {
  COLUMN = 'column',
  ROW = 'row',
}

export const TrustedPartnerContainer = ({
  direction = RenderDirection.ROW,
  staticTrustedPartners,
}: TrustedPartnerContainerProps): JSX.Element => {
  const [partners, dispatch] = React.useReducer(trustedPartnersReducer, [])
  React.useEffect(() => {
    if (!staticTrustedPartners) {
      Api.get(`${TRUSTED_PARTNER_API_URL}?limit=4`)
        .then(({ data }: { data: TrustedPartner[] }) => {
          dispatch(fetchTrustedPartnersSuccess(data))
        })
        .catch((error: Error) => {
          console.error(error)
          dispatch(fetchTrustedPartnersSuccess([]))
        })
    } else {
      dispatch(fetchTrustedPartnersSuccess(staticTrustedPartners))
    }
  }, [])

  return <TrustedPartners direction={direction} partners={partners} />
}
